/* Copyright 2022 Motorola Solutions Inc. All Rights Reserved. */
export class Features {
  constructor({ displayPersonAssignment, crossOrgDelegationSectionEnabled }) {
    this._displayPersonAssignment = displayPersonAssignment;
    this._crossOrgDelegationSectionEnabled = crossOrgDelegationSectionEnabled;
  }
  private _displayPersonAssignment: string;
  private _crossOrgDelegationSectionEnabled: string;

  public get displayPersonAssignment(): string {
    return this._displayPersonAssignment;
  }

  public get crossOrgDelegationSectionEnabled(): string {
    return this._crossOrgDelegationSectionEnabled;
  }
}
